import React from "react";
import { Link, Route, Routes } from "react-router-dom";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import Dashboard from "./pages/Dashboard";
import { theme } from "./theme";
import Biology from "./pages/Biology";
import Horizontal from "./pages/Horizontal";
import Hydrology from "./pages/Hydrology";
import Vertical from "./pages/Vertical";
import Soil from "./pages/Soil";
import Water from "./pages/Water";
import Sediment from "./pages/Sediment";
import VertSed from "./pages/VertSed";
import HorSed from "./pages/HorSed";
import HydroSed from "./pages/HydroSed";
import BioSed from "./pages/BioSed";
import Regulatory from "./pages/Regulatory";
import ScrollToTop from "./components/ScrollToTop";
import useWindowDimensions from "./tools/useWindowDimensions";
import About from "./pages/About";
import Instructions from "./pages/Instructions";
import WatchContextProvider from "./WatchContext";
import PrintReport from "./components/PrintReport";
import logo from './img/PDE.png'
import RutgersFooter from './components/njaesFooter/RutgersFooter'

const Styles = {
  Wrapper: styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${({ bgColor }) => bgColor || "white"};
    // height: 100%;
    font-family: "Poppins", sans-serif;
  `,
  PageContainer: styled.div`
    display: flex;
    justify-content: center;
    width: 100vw;
    // height: 100vh;

    @media screen and (min-width: ${({ theme }) => theme.mobile}) {
      max-width: 1366px;
    }
  `,
  Headline: styled.h1`
    margin: 2rem;
    
  `,
  HomeLink: styled(Link)`
    text-decoration: none;
    color: ${({ theme }) => theme.colors.pdeGreen};
  `,
  SmallScreen: styled.div`
  font: inherit,
                display: flex,
                height: 733px,
                justify-content: center,
                align-items: center,
                flex-direction: column,
  `,
  Header: styled.div`
  width: 100%;
  background-color: ${({theme}) => theme.colors.white};  
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 1rem;
  box-shadow: 0 3px 15px ${({ theme }) => theme.colors.grey5}40;
  `,
};

const CSSReset = createGlobalStyle`
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

html {
  font-size: 62.5%; /* 1rem = 10px */
  box-sizing: border-box;
}

body {

  font-size: 1.4rem;
  font-family: 'Poppins', sans-serif;
}
`;

console.log('rendering app')
const App = () => {
  const {
    // height,
    width,
  } = useWindowDimensions();

  return (
    
    <WatchContextProvider>
      <ThemeProvider theme={theme}>
        <CSSReset />
        <Styles.Wrapper bgColor={theme.colors.grey0}>
          <ScrollToTop>
            <Styles.Header>
            <img style={{maxWidth: '200px'}} src={logo} alt='partnership for delaware estuary'/>
            <Styles.Headline>
              <Styles.HomeLink to="/">Wetlands Assessment Tool for Condition & Health (WATCH)</Styles.HomeLink>
            </Styles.Headline>
            </Styles.Header>
            {width < 900 ? (
              <Styles.SmallScreen>
                <h1>This app is best viewed on a wider screen.</h1>
                <p>
                  If you must use this device, go to the view menu and zoom out
                  until the app appears.
                </p>
              </Styles.SmallScreen>
            ) : (
              <Styles.PageContainer>
                
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/biology" element={<Biology />} />
                  <Route path="/biosed" element={<BioSed />} />
                  <Route
                    path="/horizontal"
                    element={<Horizontal />}
                  />
                  <Route path="/horsed" element={<HorSed />} />
                  <Route path="/hydrology" element={<Hydrology />} />
                  <Route path="/hydrosed" element={<HydroSed />} />
                  <Route
                    path="/instructions"
                    element={<Instructions />}
                  />
                  <Route
                    path="/regulatory"
                    element={<Regulatory />}
                  />
                  <Route path="/sediment" element={<Sediment />} />
                  <Route path="/soil" element={<Soil />} />
                  <Route path="/vertical" element={<Vertical />} />
                  <Route path="/vertsed" element={<VertSed />} />
                  <Route path="/water" element={<Water />} />
                  <Route path="/report" element={<PrintReport />} />
                </Routes>
              </Styles.PageContainer>
            )}
            <RutgersFooter/>
          </ScrollToTop>
        </Styles.Wrapper>
      </ThemeProvider>
    </WatchContextProvider>
  );
};

export default App;
